<template>
	<b-badge style="line-height: 1.2" :variant="color_badge">{{
		date | dateBr
	}}</b-badge>
</template>

<script>
	import moment from "moment";
	export default {

		props: {
			date: {}
		},

		computed: {
			due() {
				return moment(this.date).diff(
					moment().startOf("day"),
					"days"
				)
			},

			color_badge() {
				if (this.due == 0) {
					return 'warning'
				}
				if (this.due > 0) {
					return 'primary'
				}
				if (this.due < 0) {
					return 'danger'
				}
			}
		},
	}
</script>
